import Image from 'next/image';
import Link from 'next/link';
import { PopupActions, PopupContent } from '@/components/PagePopup/PopupContent';
import { Button, Text } from '@music-vine/cadence/ui';
import { LiminalAmbientDeepDivePopup as PopupData } from '@/constants/popups';
import type { PagePopupProps, PopUpPosition, PopUpVariant } from '@/components/PagePopup/PagePopup';
const liminalAmbientCollectionRegex = /^\/music\/collection\/liminal-ambient(?:[/?#]|$)/;
export const getLiminalAmbientDeepDiveProps = ({
  logPopupClick,
  asPath
}: {
  logPopupClick: (type: string, popup_id: string, nextPath: string) => void;
  asPath: string;
}): PagePopupProps => {
  const popupId = 'liminal-ambient-deep-dive-october-2026';
  const onCtaClick = () => {
    window.postMessage({
      type: 'DISMISS_POPUP'
    }, '*');
    logPopupClick('cta', popupId, PopupData.href);
  };
  return {
    storageKey: popupId,
    variant: 'default' as PopUpVariant,
    position: 'bottom-right' as PopUpPosition,
    duration: {
      from: new Date(Date.parse('2026-10-14T00:00:00Z')),
      to: new Date(Date.parse('2026-11-04T23:59:59Z'))
    },
    includeSlugs: [liminalAmbientCollectionRegex],
    delay: 10_000,
    delayOnEveryPage: true,
    onShow: () => {
      logPopupClick('impression', popupId, asPath);
    },
    children: <PopupContent mainTitle={PopupData.mainTitle} variant="default">
        <Text className="font-sans text-gray-700 text-sm">
          {PopupData.description}
        </Text>
        <Image alt={PopupData.imgAlt} className="h-auto w-full rounded-lg" height={158} src={PopupData.imgSrc} width={280} />
        <PopupActions>
          <Button border className="text-sm" onClick={() => {
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
          logPopupClick('dismiss', popupId, asPath);
        }} variant="subtle">
            Dismiss
          </Button>
          <Button asChild className="text-sm" variant="bold">
            <Link href={PopupData.href} onClick={onCtaClick} rel="noopener noreferrer" target="_blank">
              {PopupData.cta}
            </Link>
          </Button>
        </PopupActions>
      </PopupContent>,
    onClickDismiss: () => {
      logPopupClick('dismiss', popupId, asPath);
    },
    noXIcon: {
      desktop: false,
      mobile: false
    },
    mobileChildren: <div className="flex flex-col gap-3 p-3">
        <div className="flex items-center gap-3 pr-6">
          <Image alt={PopupData.imgAlt} className="aspect-video w-28 shrink-0 rounded-lg object-cover" height={63} src={PopupData.imgSrc} width={112} />
          <div className="flex flex-col gap-1">
            <span className="font-heading font-semibold text-gray-950 text-sm leading-tight dark:text-white">
              {PopupData.mainTitle}
            </span>
            <span className="font-sans text-gray-700 text-xs dark:text-gray-200">
              {PopupData.description}
            </span>
          </div>
        </div>
        <Button asChild className="w-full text-sm" variant="bold">
          <Link href={PopupData.href} onClick={onCtaClick} rel="noopener noreferrer" target="_blank">
            {PopupData.cta}
          </Link>
        </Button>
      </div>
  };
};